<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<vs-alert
			color="danger"
			:title="$t('VisitPointObject.Edit.VisitPointNotFound.Title')"
			:active.sync="vp_not_found"
		>
			{{
				$t("VisitPointObject.Edit.VisitPointNotFound.Text1") +
				" " +
				$route.params.id +
				" " +
				$t("VisitPointObject.Edit.VisitPointNotFound.Text2")
			}}
			<span>{{ $t("Resource.Edit.UserNotFound.Check") }} </span>
			<router-link :to="{name: 'app-visit-point-list'}" class="text-inherit underline"
				>{{ $t("ListVisitPoint") }}
			</router-link>
		</vs-alert>
		<bread-crumbs
			:title="$t('VisualizeVisitPoint')"
			:subTitle="$t('general.SubtitleDetailedInformation') + ' ' + $t('VisitPoint')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div id="user-data" v-if="user_data">
			<vx-card class="mb-base">
				<div class="vx-row mb-2">
					<div class="vx-col w-full flex items-center p-0">
						<feather-icon
							class="g-breadcrumb--title"
							icon="ChevronLeftIcon"
							svgClasses="h-8 w-8"
							@click.prevent="$router.push({name: 'app-visit-point-list'})"
						/>
						<vs-breadcrumb
							class="g-breadcrumb--title"
							separator=""
							:items="[{title: $t('general.Return')}]"
							@click.prevent="$router.push({name: 'app-visit-point-list'})"
						></vs-breadcrumb>
					</div>
				</div>
				<span class="g-subtitle" v-text="$t('general.Account')"></span>
				<!-- Avatar -->
				<div class="vx-row mt-4">
					<div class="vx-col flex-1" id="account-info-col-1">
						<table>
							<tr>
								<td class="g-table--title" v-text="$t('Name')"></td>
								<td class="g-label--normal">{{ user_data.name }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('Identification')"></td>
								<td class="g-label--normal">{{ user_data.identification }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('Phone')"></td>
								<td class="g-label--normal">{{ user_data.phone }}</td>
							</tr>
						</table>
					</div>
					<div class="vx-col flex-1" id="account-info-col-2">
						<table>
							<tr>
								<td class="g-table--title" v-text="$t('Status')"></td>
								<td class="g-label--normal">{{ user_data.status_name }}</td>
							</tr>
							<tr>
								<td class="g-table--title" v-text="$t('ObjectType')"></td>
								<td class="g-label--normal">{{ categoryName(user_data.typology_id) }}</td>
							</tr>
						</table>
					</div>
					<!-- /Information - Col 2 -->
					<div class="vx-col w-full flex justify-end" id="account-manage-buttons">
						<vs-button
							icon-pack="feather"
							icon="icon-edit"
							class="mr-4"
							:size="iconSize"
							:title="$t('Crud.Update')"
							:to="{
								name: 'app-visit-point-edit',
								params: {id: $route.params.id},
							}"
							>{{ windowWidth > 620 ? $t("Crud.Update") : null }}
						</vs-button>
						<vs-button
							color="warning"
							icon-pack="feather"
							icon="icon-bar-chart-2"
							class="mr-4"
							:size="iconSize"
							:title="$t('Statistics2.Statistics')"
							:to="{
								name: 'app-visit-point-recurrence',
								params: {id: $route.params.id},
							}"
							>{{ windowWidth > 620 ? $t("Statistics2.Statistics") : null }}
						</vs-button>
						<vs-button
							color="danger"
							icon-pack="feather"
							icon="icon-trash"
							class="mr-4"
							:size="iconSize"
							:title="$t('Crud.Delete')"
							@click.prevent="confirmDeleteRecord"
							>{{ windowWidth > 620 ? $t("Crud.Delete") : null }}
						</vs-button>
						<vs-button
							type="filled"
							color="success"
							icon-pack="feather"
							icon="icon-list"
							:size="iconSize"
							:title="$t('CreatePasswordVP.GoTo') + ' ' + $t('ListVisitPoint')"
							:to="{name: 'app-visit-point-list'}"
							>{{ windowWidth > 620 ? $t("CreatePasswordVP.GoTo") + " " + $t("ListVisitPoint") : null }}
						</vs-button>
					</div>
				</div>
			</vx-card>
			<vx-card>
				<vs-tabs>
					<vs-tab
						icon-pack="feather"
						icon="icon-info"
						:label="$t('general.LocationInformation') | capitalize"
					>
						<vx-card card-border no-shadow class="mb-base mt-base">
							<table class="mt-4">
								<tr>
									<td class="g-table--title" v-text="$t('Address')"></td>
									<td class="g-label--normal">{{ user_data.address }}</td>
								</tr>
								<tr>
									<td class="g-table--title" v-text="$t('City')"></td>
									<td class="g-label--normal">{{ user_data.city }}</td>
								</tr>
								<tr>
									<td class="g-table--title" v-text="$t('Country')"></td>
									<td class="g-label--normal">{{ user_data.country }}</td>
								</tr>
								<tr>
									<td class="g-table--title" v-text="$t('Routing.Table.Longitude')"></td>
									<td class="g-label--normal">{{ user_data.cx }}</td>
								</tr>
								<tr>
									<td class="g-table--title" v-text="$t('Routing.Table.Latitude')"></td>
									<td class="g-label--normal">{{ user_data.cy }}</td>
								</tr>
							</table>
						</vx-card>
					</vs-tab>
					<vs-tab icon-pack="feather" icon="icon-box" :label="$t('Object.AdditionalFields')">
						<vs-tabs
							v-if="
								Object.keys(additionalFieldsFile).length > 0 ||
								Object.keys(additionalFieldsBasics).length > 0 ||
								Object.keys(additionalFieldsImg).length > 0
							"
							position="left"
							color="success"
						>
							<vs-tab
								v-if="Object.keys(additionalFieldsBasics).length > 0"
								icon-pack="feather"
								icon="icon-file-text"
								:label="$t('Object.Basics')"
							>
								<vx-card no-shadow card-border>
									<table class="mt-base">
										<tr v-for="(val, name) in additionalFieldsBasics" :key="name">
											<td class="g-table--title">{{ name | capitalizeFilter }}</td>
											<td class="g-label--normal">{{ val }}</td>
										</tr>
									</table>
								</vx-card>
							</vs-tab>
							<vs-tab
								v-if="Object.keys(additionalFieldsFile).length > 0"
								icon-pack="feather"
								icon="icon-file"
								:label="$t('general.Files')"
							>
								<div class="vx-row" v-if="Object.keys(additionalFieldsFile).length > 0">
									<div
										class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base mt-base"
										v-for="(val, name) in additionalFieldsFile"
										:key="name"
									>
										<vx-card card-border>
											<img
												:src="renderImgFileExtension(val)"
												style="height: 90px; width: 100%"
												:title="renderImgFileCompleteName(val)"
												class="rounded w-full"
											/>
											<div class="flex justify-between mt-2">
												<label class="g-table--title mr-2" v-text="$t('Name')"></label>
												<table>
													<tr>
														<td class="g-label--normal">
															{{ renderImgFileCompleteName(val) }}
														</td>
													</tr>
												</table>
											</div>
											<vs-button
												class="w-full"
												color="primary"
												:title="$t('ManualData.DownloadFile')"
												icon-pack="feather"
												icon="icon-download"
												@click="downloadFile(val)"
												>{{ $t("ManualData.DownloadFile") }}
											</vs-button>
										</vx-card>
									</div>
								</div>
							</vs-tab>
							<vs-tab
								v-if="Object.keys(additionalFieldsImg).length > 0"
								icon-pack="feather"
								icon="icon-image"
								:label="$t('general.Images')"
							>
								<div v-if="mounted">
									<swiper
										class="swiper"
										:options="swiperOption"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:key="$vs.rtl"
									>
										<swiper-slide
											v-for="(val, name) in additionalFieldsImg"
											:key="name"
											class="slide"
										>
											<div class="flex flex-row justify-end">
												<vs-button
													icon-pack="feather"
													icon="icon-download"
													class="mt-2 mr-6 mb-2 g-label--normal text-white"
													:title="$t('ManualData.DownloadFile')"
													@click="downloadFile(val)"
													>{{ $t("ManualData.Download") }}
												</vs-button>
											</div>
											<img class="responsive" :src="val" alt="banner" />
										</swiper-slide>
										<div class="swiper-button-prev" slot="button-prev"></div>
										<div class="swiper-button-next" slot="button-next"></div>
									</swiper>
								</div>
							</vs-tab>
						</vs-tabs>
						<vs-alert v-else active class="mb-5" color="primary">
							<span class="g-label--normal text-primary"> {{ $t("Object.NotAdditionalFields") }} </span>
						</vs-alert>
					</vs-tab>
					<vs-tab icon-pack="feather" icon="icon-users" :label="$t('Activity.AssignedResources')">
						<vx-card no-shadow card-border class="mb-base mt-base" v-if="resourcesAssigned.length > 0">
							<div id="resource-content-loading" class="vs-con-loading__container">
								<vs-table max-items="5" :data="resourcesAssigned" search>
									<div
										slot="header"
										class="flex flex-wrap-reverse items-center flex-grow justify-between"
									>
										<div class="flex items-center">
											<label
												class="g-table--title mr-2"
												v-text="$t('Resource.TotalResources')"
											></label>
											<div
												class="o-span--count bg-primary"
												v-text="resourcesAssigned.length"
											></div>
										</div>
									</div>
									<template slot="thead">
										<vs-th class="g-table--title">ID</vs-th>
										<vs-th class="g-table--title">{{ $t("Name") }}</vs-th>
										<vs-th class="g-table--title">{{ $t("Lastname") }}</vs-th>
										<vs-th class="g-table--title">{{ $t("Username") }}</vs-th>
										<vs-th class="g-table--title">{{ $t("Identification") }}</vs-th>
										<vs-th class="g-table--title">{{ $t("Email") }}</vs-th>
										<vs-th class="g-table--title">{{ $t("Actions") }}</vs-th>
									</template>
									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td class="g-table--description" :data="data[indextr].id">
												{{ data[indextr].id }}
											</vs-td>
											<vs-td class="g-table--description" :data="data[indextr].id">
												{{ data[indextr].name.toLowerCase() | capitalize }}
											</vs-td>

											<vs-td class="g-table--description" :data="data[indextr].id">
												{{ data[indextr].lastname.toLowerCase() | capitalize }}
											</vs-td>

											<vs-td class="g-table--description" :data="data[indextr].id">
												{{ data[indextr].username }}
											</vs-td>

											<vs-td class="g-table--description" :data="data[indextr].id">
												{{ data[indextr].identification }}
											</vs-td>

											<vs-td class="g-table--description" :data="data[indextr].id">
												{{ data[indextr].email }}
											</vs-td>

											<vs-td class="g-table--description" :data="data[indextr].id">
												<feather-icon
													class="g-label--normal"
													size="small"
													icon="ExternalLinkIcon"
													svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
													:title="$t('View') + ' ' + $t('Information')"
													@click="goTo(data[indextr].id)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
								<vs-pagination
									:total="pagination.total_pages"
									v-model="pagination.current_page"
								></vs-pagination>
							</div>
						</vx-card>
					</vs-tab>
					<vs-tab icon-pack="feather" icon="icon-smartphone" :label="$t('CreatePasswordVP.OnDemandUser')">
						<vx-card v-if="checkOnDemandModule" no-shadow card-border class="mb-base mt-base">
							<div class="vx-row mb-6" v-if="user_data.visit_point_user_id">
								<div class="vx-col w-full">
									<vs-alert active class="mb-5" color="primary">
										<span class="g-label--normal text-primary">
											{{ OnDemandAlertMessage }}
										</span>
									</vs-alert>
								</div>
							</div>
							<div class="vx-row mb-6" v-else>
								<div class="vx-col w-full mb-5">
									<p class="g-label--normal">{{ $t("CreatePasswordVP.EnableOnDemandUserText") }}.</p>
								</div>
								<div class="vx-col md:w-1/2">
									<label class="g-label">{{ $t("Country") }}</label>
									<v-select
										class="w-full"
										v-model="selectedCountry"
										:options="dataCountries"
										:clearable="false"
										:closeOnSelect="true"
									/>
								</div>

								<div class="vx-col md:w-1/4 mb-base">
									<label class="g-label">{{ $t("Phone") }}</label>
									<vs-input class="w-full" v-model="newPhone" type="number" />
								</div>

								<div class="vx-col md:w-1/4 mb-base">
									<span class="g-label">{{ $t("Crud.Update") }} {{ $t("Phone") }}:</span>
									<vs-switch v-model="updatePhone"></vs-switch>
								</div>

								<div class="vx-col w-full mb-base">
									<vs-button
										icon-pack="feather"
										icon="icon-phone-outgoing"
										class="float-right"
										@click="sendCode"
										>{{ promptTitle | capitalize }}
									</vs-button>
								</div>
							</div>
						</vx-card>

						<vx-card
							no-shadow
							card-border
							:title="$t('CreatePasswordVP.OnDemandUser')"
							class="mb-base mt-base"
							v-else
						>
							<vs-alert
								active
								class="mb-base"
								icon-pack="feather"
								icon="icon-shopping-bag"
								color="warning"
							>
								{{ $t("general.NoModule") }}
							</vs-alert>
						</vx-card>
					</vs-tab>
				</vs-tabs>
			</vx-card>
		</div>
	</div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import countries from "@/helpers/country";
import vSelect from "vue-select";
import UploadedFile from "@/models/UploadedFile.js";
import ManageErrorMessages from "@/models/ManageErrorMessages.js";
import {swiper, swiperSlide} from "vue-awesome-swiper";

export default {
	components: {
		vSelect,
		swiper,
		swiperSlide,
	},
	data() {
		return {
			user_data: null,
			vp_not_found: false,
			updatePhone: false,
			newPhone: "",
			selectedCountry: {
				value: "+57",
				label: "Colombia (+57)",
			},
			urlDecoded: {fileName: new Date().getTime() + "", fileExtension: "unknown"},
			mounted: false,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			swiperOption: {
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			pagination: {
				next_page: "",
				total_pages: 0,
				total_records: 0,
				current_page: 1,
			},
		};
	},
	computed: {
		userAddress() {
			let str = "";
			for (const field in this.user_data.address) {
				str += `${field} `;
			}
			return str;
		},
		categories() {
			return this.$store.state.moduleCommon.dataSelectVisitPoint.category;
		},
		dataCountries() {
			return countries
				.filter((country) => country.code_num.charAt(0) === "+")
				.map(({code, code_num, name}) => ({
					value: code_num,
					label: `${name} (${code_num})`,
				}));
		},
		promptTitle() {
			return `${this.$t("Submit")} ${this.$t("CreatePasswordVP.ValidationCode")}`;
		},
		checkOnDemandModule() {
			const config = this.$store.getters["moduleCompanyConfig/modulesConfig"];
			if (config) {
				return config.config_json.on_demand;
			}
			return false;
		},
		/**
		 * filtrar los campos adicioneles que no sean tipo imagen o tipo archivo
		 */
		additionalFieldsBasics() {
			const vpFilter = this.user_data.category_json_properties.filter(
				({additional, type}) => additional === true && type !== "img" && type !== "file"
			);
			const filterObj = {};
			for (const key in this.user_data.additional_info) {
				if (Object.hasOwnProperty.call(this.user_data.additional_info, key)) {
					const element = this.user_data.additional_info[key];
					if (vpFilter.some((vpfilter) => vpfilter.name === key)) {
						filterObj[key] = element;
					}
				}
			}
			return filterObj;
		},
		/**
		 * filtrar los campos adicioneles que sean tipo imagen o tipo archivo
		 */
		additionalFieldsImg() {
			const vpFilter = this.user_data.category_json_properties.filter(
				({additional, type}) => additional === true && type === "img"
			);
			const filterObj = {};
			for (const key in this.user_data.additional_info) {
				if (Object.hasOwnProperty.call(this.user_data.additional_info, key)) {
					const element = this.user_data.additional_info[key];
					if (vpFilter.some((vpfilter) => vpfilter.name === key)) {
						filterObj[key] = element;
					}
				}
			}
			return filterObj;
		},
		/**
		 * filtrar los campos adicioneles que sean tipo imagen o tipo archivo
		 */
		additionalFieldsFile() {
			const vpFilter = this.user_data.category_json_properties.filter(
				({additional, type}) => additional === true && type === "file"
			);
			const filterObj = {};
			for (const key in this.user_data.additional_info) {
				if (Object.hasOwnProperty.call(this.user_data.additional_info, key)) {
					const element = this.user_data.additional_info[key];
					if (vpFilter.some((vpfilter) => vpfilter.name === key)) {
						filterObj[key] = element;
					}
				}
			}
			return filterObj;
		},
		renderImgFileExtension() {
			return (params) => {
				const obj = {...this.decodeUrl(params)};
				try {
					return require(`@/assets/images/svg-icons/${obj.fileExtension}.svg`);
				} catch (error) {
					return require("@/assets/images/svg-icons/file-plus.svg");
				}
			};
		},
		renderImgFileCompleteName() {
			return (params) => {
				const obj = {...this.decodeUrl(params)};
				return `${obj.fileName}.${obj.fileExtension}`;
			};
		},
		resourcesAssigned() {
			return this.$store.state.moduleResource.resources.filter((resource) => resource.role_name !== "ADMIN");
		},
		OnDemandAlertMessage() {
			return this.user_data.visit_point_user_id
				? this.$t("CreatePasswordVP.VisitPointAlreadyRegister")
				: "Punto de visita no cuenta con usuario para ondemand por favor envie un codigo al numero de celular";
		},
		OnDemandCardTitle() {
			return this.user_data.visit_point_user_id
				? this.$t("CreatePasswordVP.OnDemandUser")
				: this.$t("CreatePasswordVP.EnableOnDemandUser");
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Zonification.ConfirmRemoveLayerAndZones.Title"),
				text: this.$t("Resource.List.CellRenderer.DeleteRecord") + " " + `"${this.user_data.name}"`,
				accept: this.deleteRecord,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			/* Below two lines are just for demo purpose */
			this.$store
				.dispatch("moduleVisitPoint/removeVisitPoint", this.user_data.id)
				.then((res) => {
					this.$router.push({name: "app-visit-point-list"});
					this.showDeleteSuccess();
					return res;
				})
				.catch((err) => {
					if (err.response.status === 404) {
						//this.vp_not_found = true;
						return;
					}
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Object.UserDeleted.Title"),
				text: this.$t("Object.UserDeleted.Text"),
			});
		},
		categoryName(value) {
			if (this.categories === undefined) {
				return;
			}
			const foundCategory = this.categories.find((category) => category.typology_id === value);
			if (foundCategory) {
				return foundCategory.typology_name;
			} else {
				return value;
			}
		},
		sendCode() {
			const payload = {
				visit_point_id: this.user_data.id,
				cell_phone: this.selectedCountry.value + "" + this.newPhone,
				update: this.updatePhone,
			};
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/sendCode", payload)
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("CreatePasswordVP.ValidationCode"),
						text: this.$t("CreatePasswordVP.SentCode"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					if (Object.hasOwnProperty.call(err.data, "reason")) {
						this.manageErrorMessages.setErrorMessage(err.data.reason);
					}
					this.manageErrorMessages.showMessage();
				});
		},
		async downloadFile(urlFile) {
			const uploadedFile = new UploadedFile({});
			if (!urlFile) return;
			const obj = {...this.decodeUrl(urlFile)};
			this.openLoading();
			try {
				await uploadedFile.downloadFile(obj.fileName, urlFile);
				this.$vs.notify({
					color: "success",
					title: this.$t("Notification.DOWNLOAD_FINALIZED"),
					text: `${this.$t("Reports.FileName")} : ${obj.fileName}`,
					time: 8000,
					fixed: false,
				});
				this.closeLoading();
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("UploadFiles.FileNotFound"),
					text: `${this.$t("UploadFiles.DownloadFailedText")}`,
					time: 8000,
					fixed: false,
				});
				this.closeLoading();
			}
		},
		decodeUrl(url = "") {
			const decodeUrl = decodeURIComponent(url);
			const urlSlashSplitted = decodeUrl.split("/");
			const splittedByQuestion = urlSlashSplitted[urlSlashSplitted.length - 1].split("?")[0];
			const splittedByDot = splittedByQuestion.split(".");
			if (Array.isArray(splittedByDot)) {
				if (splittedByDot.length > 2) {
					return {
						fileName: `${splittedByDot[0]}.${splittedByDot[1]}`,
						fileExtension: splittedByDot[splittedByDot.length - 1].toLowerCase(),
					};
				} else {
					if (splittedByDot.length > 1)
						return {
							fileName: splittedByDot[0],
							fileExtension: splittedByDot[1].toLowerCase(),
						};
					return {fileName: splittedByDot[0]};
				}
			}
			return this.urlDecoded;
		},
		goTo(resourceId) {
			this.$router.push(`/apps/resource/resource-view/${resourceId}`);
		},

		openLoadingContent(idContent) {
			this.$vs.loading({
				container: idContent,
				scale: 0.6,
			});
		},
		closeLoadingContent(idContent) {
			this.$vs.loading.close(`${idContent} > .con-vs-loading`);
		},
		async getAssignedResourcesByIds(page = 1) {
			this.openLoadingContent("#resource-content-loading");
			const result = await this.$store.dispatch("moduleResource/fetchResourceFilter", {
				page,
				quantity: 10,
				ids: this.user_data.resource_id,
				fields: ["id", "name", "lastname", "username", "email", "identification"],
			});
			this.pagination = {...this.pagination, ...result.pagination};
			this.closeLoadingContent("#resource-content-loading");
		},
	},
	watch: {
		"pagination.current_page"(val) {
			this.getAssignedResourcesByIds(val);
		},
	},
	mounted() {
		this.mounted = true;
	},
	created() {
		// Register Module UserManagement Module
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		// Register Module VisitPoint Module
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		if (this.$store.state.moduleCommon.dataSelectVisitPoint.category === undefined) {
			this.$store.dispatch("moduleCommon/fetchDataSelectVisitPoint").catch((error) => {
				throw new Error(error);
			});
		}

		// Fetch to visit point service
		const id = this.$route.params.id;
		this.openLoading();
		this.$store
			.dispatch("moduleVisitPoint/fetchVisitPointById", id)
			.then((res) => {
				this.user_data = res;
				if (this.user_data.total_resource) {
					return this.$store.dispatch("moduleResource/fetchResourceFilter", {
						page: 1,
						quantity: 10,
						ids: this.user_data.resource_id,
						fields: ["id", "name", "lastname", "username", "email", "identification"],
					});
				}
				return null;
			})
			.then((res) => {
				if (!res) {
					throw new Error("Not found vp");
				}
				this.pagination = {...this.pagination, ...res.data.pagination};
				this.closeLoading();
			})
			.catch((err) => {
				this.closeLoading();
				if (err.status === 400) {
					this.vp_not_found = true;
					return;
				}
				console.error(err);
			});
	},
	filters: {
		capitalizeFilter: function (value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
</style>
